var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.isMobile)?[_c('LoginStar'),_c('HomePage',{attrs:{"isMobile":false}})]:[_c('iframe',{staticStyle:{"width":"100%","height":"100%","position":"absolute","top":"0","left":"0","z-index":"-1"},attrs:{"src":"/mHome/mHome.html","frameborder":"0"}}),_c('HomePage',{attrs:{"isMobile":true}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }